/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetZReport200ResponseShiftsValue
 */
export interface GetZReport200ResponseShiftsValue {
    /**
     * 
     * @type {string}
     * @memberof GetZReport200ResponseShiftsValue
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseShiftsValue
     */
    startAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseShiftsValue
     */
    endAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseShiftsValue
     */
    expectedEndAmount: number;
}

/**
 * Check if a given object implements the GetZReport200ResponseShiftsValue interface.
 */
export function instanceOfGetZReport200ResponseShiftsValue(value: object): value is GetZReport200ResponseShiftsValue {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('startAmount' in value) || value['startAmount'] === undefined) return false;
    if (!('endAmount' in value) || value['endAmount'] === undefined) return false;
    if (!('expectedEndAmount' in value) || value['expectedEndAmount'] === undefined) return false;
    return true;
}

export function GetZReport200ResponseShiftsValueFromJSON(json: any): GetZReport200ResponseShiftsValue {
    return GetZReport200ResponseShiftsValueFromJSONTyped(json, false);
}

export function GetZReport200ResponseShiftsValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetZReport200ResponseShiftsValue {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'startAmount': json['startAmount'],
        'endAmount': json['endAmount'],
        'expectedEndAmount': json['expectedEndAmount'],
    };
}

export function GetZReport200ResponseShiftsValueToJSON(json: any): GetZReport200ResponseShiftsValue {
    return GetZReport200ResponseShiftsValueToJSONTyped(json, false);
}

export function GetZReport200ResponseShiftsValueToJSONTyped(value?: GetZReport200ResponseShiftsValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'startAmount': value['startAmount'],
        'endAmount': value['endAmount'],
        'expectedEndAmount': value['expectedEndAmount'],
    };
}

